<template>
  <div>
    <div class="tabs is-separatedUnderlined is-fullwidth is-marginless">
      <ul class="has-text-weight-medium">
        <li :class="{'is-active':panel === 'INFOS'}"><a @click="panel = 'INFOS'">Informations société</a></li>
        <!-- <li v-if="!isNew" :class="{'is-active':panel === 'DOCS'}"><a @click="panel = 'DOCS'">Documents</a></li> -->
      </ul>
    </div>
    <div class="has-bg-brand is-padding-left is-padding-right is-margin-top-xsmall">
      <div class="has-text-white is-size-6 is-padding-top-xsmall is-padding-bottom-xsmall">
        <span class="icon is-small is-size-7"><i class="fas fa-check-circle"></i></span>
        <i>Information obligatoire pour la validation du formulaire</i>
      </div>
    </div>
    <form @submit.prevent.stop="submit()">
      <div v-show="panel === 'INFOS'">
        <div class="columns is-multiline has-bg-light">
          <div class="column is-12 is-paddingless-bottom">
            <div class="title is-5">
              <b class="is-uppercase">Représentant de la société </b><i>(responsable administratif)</i>
            </div>
            <div class="subtitle is-6 has-text-grey">
              Le responsable de la société est la seule personne en mesure de valider les mandats. Il ne reçoit
              aucune autre notification.
            </div>
          </div>
          <div class="column is-gapless is-paddingless is-12 columns is-multiline">
            <div class="column is-6 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <label class="label" for="person_name">Nom</label>
                <v-input name="person_name" @input="val => company.person_in_charge_last_name = val"
                        :model="company.person_in_charge_last_name"
                        classes="input"
                        :errors-bag="errors" data-vv-value-path="val" data-vv-as="Nom">
                </v-input>
              </div>
            </div>
            <div class="column is-6 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <label class="label" for="first_name">Prénom</label>
                <div class="control">
                  <v-input name="first_name" @input="val => company.person_in_charge_first_name = val"
                          :model="company.person_in_charge_first_name"
                          classes="input"
                          :errors-bag="errors" data-vv-value-path="val" data-vv-as="Prénom">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-6 is-padding">
              <div class="field">
                <r-label :label="'Adresse mail'" :value="company.person_in_charge_email" :redCheck='hasCheck' :is-required="hasCheck"></r-label>
                <div class="control">
                  <v-input name="email" @input="val => company.person_in_charge_email = val"
                          :model="company.person_in_charge_email"
                          classes="input"
                          :errors-bag="errors" data-vv-value-path="val" data-vv-as="Email">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-6 is-padding">
              <div class="field">
                <r-label :label="'Téléphone (fixe ou mobile)'" :value="company.person_in_charge_phone" :redCheck='hasCheck' :is-required="hasCheck"></r-label>
                <div class="control">
                  <the-mask :mask="$configs.COUNTRY === 'FRA' ? '## ## ## ## ##' : '####################'"
                             v-model="company.person_in_charge_phone" id="phone" name="phone" class="input"
                             @input="val => company.person_in_charge_phone = val" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-multiline is-border-top">
          <div class="column is-12 is-paddingless-bottom">
            <div class="title is-5">
              <b class="is-uppercase">Informations société</b>
            </div>
          </div>
          <div class="column is-gapless is-paddingless is-12 columns is-multiline">
            <div class="column is-6 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <r-label :label="'Nom de la societe'" :value="company.name"></r-label>
                <div class="control">
                  <v-input id="name" name="name" @input="val => company.name = val" :model="company.name"
                          classes="input"
                          v-validate="'required|min:2'" :errors-bag="errors" data-vv-value-path="val"
                          data-vv-as="Nom *">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-3 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <label class="label" for="remuneration">
                  Commission en %
                </label>
                <div class="field has-addons">
                  <div class="control">
                    <a class="button is-square is-static is-border is-min-width-0">
                      <span class="icon"><i class="far fa-percentage"></i></span>
                    </a>
                  </div>
                  <div class="control is-expanded has-icons-right">
                    <input name="remuneration" v-model.number="company.remuneration"
                      class="input" step=".01" max="100" type="number"
                      data-type-cy="input" data-value-cy="input_com_company">
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-3 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <label class="label" for="ref">N° de societe</label>
                <div class="control">
                  <v-input id="ref" name="ref" @input="val => company.ref = val" :model="company.ref"
                          classes="input"
                          v-validate="'min:2'" :errors-bag="errors" data-vv-value-path="val"
                          data-vv-as="N° de societe">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-12">
              <div class="field">
                <div class="control">
                  <gmap-input :source="address" @submit="updateAddress" :redCheck='hasCheck' :is-required="hasCheck"></gmap-input>
                </div>
              </div>
            </div>
            <div class="column is-6 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <label class="label" for="societeTel">Téléphone (fixe ou mobile)</label>
                <div class="control">
                  <the-mask :mask="$configs.COUNTRY === 'FRA' ? '## ## ## ## ##' : '####################'"
                    v-model="company.phone" id="companyPhone" name="companyPhone" class="input" />
                </div>
              </div>
            </div>
            <div class="column is-6 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <label class="label" for="fax">Fax</label>
                <div class="control">
                  <v-input name="fax" @input="val => company.fax = val" :model="company.fax" classes="input"
                          :errors-bag="errors" data-vv-value-path="val" data-vv-as="FAX">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-4 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <r-label :label="'Numéro siret'" :redCheck='hasCheck' :value="company.siret" :is-required="hasCheck"></r-label>
                <div class="control">
                  <v-input name="siret" @input="val => company.siret = val" :model="company.siret" classes="input"
                          :errors-bag="errors" data-vv-value-path="val" data-vv-as="SIRET">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-4 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <r-label :label="'Numéro siren'" :redCheck='hasCheck' :value="company.siren" :is-required="hasCheck"></r-label>
                <div class="control">
                  <v-input name="siren" @input="val => company.siren = val" :model="company.siren" classes="input"
                          :errors-bag="errors" data-vv-value-path="val" data-vv-as="SIREN">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-4 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <r-label :label="'Tva intracommunautaire'" :redCheck='hasCheck' :value="company.tva_intra" :is-required="hasCheck"></r-label>
                <div class="control">
                  <v-input name="tva_intra" @input="val => company.tva_intra = val" :model="company.tva_intra" classes="input"
                        :errors-bag="errors" data-vv-value-path="val" data-vv-as="RCS">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-12 is-paddingless">
              <div class="columns">
                <div class="column">
                  <div class="field">
                    <label class="label is-padding-bottom-xsmall">Logo de la société
                      <span class="is-size-3 is-margin-left-xsmall"
                            v-helper.right="'4B6D9fET04y6UgQsEkAqoM'">
                        <i class="fal fa-question-circle fa-xs has-text-grey"></i>
                      </span>
                    </label>
                  </div>
                  <div class="control">
                    <upload-file @upload="uploadImage" :documents="pictures" :multiple="false" @deleteDocuments="deleteDocuments"
                                :is-image="true" :unique="true" :canDrag='false' :ratio="1" :circle="true"></upload-file>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formActionsSticky is-bottom is-margin-top">
        <div class=" columns is-gapless is-centered has-bg-white is-padding-top-small is-padding-bottom-small">
          <div class="column is-4 is-3-widescreen is-margin-right-small">
            <a @click="$router.goBack(route)" class="button is-light is-uppercase is-fullwidth">
              <span>Annuler</span>
            </a>
          </div>
          <div class="column is-4 is-3-widescreen is-margin-left-small">
            <button class="button is-success is-uppercase is-fullwidth has-text-white" type="submit"
                  :disabled="!canSubmit || loading" :class="{'is-loading':loading}">
              <span v-if="!loading">Valider</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { isEmpty } from 'lodash'

  let emptyCompany = {
    person_in_charge_gender: null,
    person_in_charge_last_name: null,
    person_in_charge_first_name: null,
    person_in_charge_email: null,
    person_in_charge_phone: null,
    name: null,
    siret: null,
    siren: null,
    tva_intra: null,
    fax: null,
    phone: null,
    picture: {},
    address: {},
    remuneration: null
  }

  export default {
    name: 'CompanyForm',
    data () {
      return {
        company: {},
        users: [],
        pictures: [],
        address: null,
        isNew: false,
        panel: 'INFOS',
        route: this.$route,
        hasCheck: false
      }
    },
    props: {
      source: {
        required: false
      },
      loading: {
        type: Boolean
      }
    },
    computed: {
      ...mapState(['currentUser']),
      canSubmit () {
        return this.errors.any() === false
      }
    },
    methods: {
      deleteDocuments () {
        this.pictures = []
        this.company.picture = null
      },
      updateAddress ({address, location}) {
        this.$set(this, 'address', address)
      },
      submit (redirect = true) {
        this.$validator.validateAll()
          .then(isValid => {
            if (isValid) {
              if (!this.company.picture || !this.company.picture.path) {
                this.company.picture = null
              }
              if (this.address && this.address.city && this.address.zip_code) {
                this.company.address = Object.assign({}, this.address)
              } else {
                delete this.company.address
              }
              if (!this.company.remuneration) this.company.remuneration = null
              this.$emit('submit', this.company, redirect)
            } else {
              this.$notify({
                type: 'is-danger',
                text: 'Oups ! Merci de compléter les champs obligatoires.'
              })
            }
          })
          .catch(err => {
            console.log('form validation error > ', err)
          })
      },
      uploadImage (e) {
        this.pictures = e
        if (e && e[0]) {
          this.$set(this.company, 'picture', e[0])
          if (this.company.pk) {
            this.submit(false)
          }
        } else {
          this.$set(this.company, 'picture', null)
        }
      }
    },
    created () {
      if (this.source) {
        this.company = Object.assign(this.company, this.source)
        this.address = Object.assign({}, this.source.address)
      } else {
        this.isNew = true
        this.company = Object.assign(this.company, emptyCompany)
      }
      if (isEmpty(this.company.picture)) this.pictures = []
      else this.pictures.push(this.company.picture)
      if ('check' in this.$route.query) {
        this.hasCheck = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/company/CompanyForm.vue